import { render } from "./CardIcon.vue?vue&type=template&id=9d90c640&ts=true"
import script from "./CardIcon.vue?vue&type=script&lang=ts"
export * from "./CardIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__